export class ScheduleBlockRuleEntity {
    scheduleBlockRuleId: string
    companyId: string
    scheduleIds: string[]
    weekdays: number[]
    startMinute: number
    endMinute: number
    startDate: Date
    endDate?: Date
    timezone: number
    label?: string
    notes?: string
    status: number
    createdAt: Date
    updatedAt: Date
}
